import { render, staticRenderFns } from "./PartnershipJ.vue?vue&type=template&id=41bfb2fc&scoped=true"
import script from "./PartnershipJ.vue?vue&type=script&lang=js"
export * from "./PartnershipJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bfb2fc",
  null
  
)

export default component.exports